
require(["readium_shared_js/globalsSetup", "readium_js_viewer/ReadiumViewer"]);
